import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'DialogInfo',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: false,
    },
    buttonText: {
      type: String,
      required: false,
    },
    smallButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    isVisible(newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'confirm'],
})
export default class DialogInfo extends Vue {
  isVisible!: boolean;
  title!: string;
  message!: string;
  buttonText!: string;
  smallButton!: boolean;
  isDialogVisible = false;

  get dialogTitle() {
    return this.title;
  }

  get dialogMessage() {
    return this.message;
  }

  get dialogButtonText() {
    return this.buttonText || this.$t('AppResource.Ok').toString();
  }


  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    this.$emit('confirm');
    this.handleHideDialog();
  }
}
